import React, { useEffect, useRef, useState } from 'react'

import logoIconSvg2 from '../../static/image/logo-icon.svg'
import reportPreviewStyles from './my-report-preview.module.less'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'
import {Layout,message,Col,Row,Button,Menu,Tooltip} from 'antd'
import { RightCircleOutlined} from '@ant-design/icons'
import  marked  from 'marked'

import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'

import { getChapterLabels } from '../common/utils/util'

const { SubMenu } = Menu

export interface Props {}

/** 查看 预览 某一个用户某个项目的报告 */
export const UserReportPreview: React.FC<Props> = (props) => {
  const projectId = parseInt(window.location.search.split('=')[1]) //项目的ID
  const userId = parseInt(window.location.search.split('&')[1].split('=')[1]) //用户ID
  const classroomId = parseInt(
    window.location.search.split('&')[2].split('=')[1]
  ) //教师ID
  const reportId = useRef(-1)

  const [project, setProject] = useState(null as any)

  const [report, setReport] = useState(null as any) //项目报告

  const [userInfo, setUserInfo] = useState(null as any) //当前用户的信息
  const [classRoomInfo, setClassRoomInfo] = useState(null as any) //班级信息

  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher 为1表示是教师
  const [isInCollege, setIsInCollege] = useState(null as any) //
  const [isCollegeTeacher, setIsCollegeTeacher] = useState(null as any) //

  const [projectMenu, setProjectMenu] = useState([] as any[]) //项目的大纲
  const [reportMenu, setReportMenu] = useState([] as any[]) //报告的大纲
  const [openkeys, setOpenKeys] =  useState(null) //展开大纲

  const [submissionInfo, setSubmissionInfo] = useState<any>()
  const [submissionInfoCount, setSubmissionInfoCount] = useState<any>()

  const mainContentRef = useRef(null) //右侧内容div
  const [mainContentWidth, setMainContentWidth] = useState(0) //右侧内容div 宽度

  const refresh_table_tds = ()=>{
    setTimeout(function(){
      const table_tds = document.getElementsByTagName("td") //以下代码设置页面表格内容属性
      console.log(table_tds)
      for(let i=0; i < table_tds.length;  i++){
          try{
            console.log(table_tds[i].innerText)
            table_tds[i].setAttribute('title', table_tds[i].innerText);
          }catch(error1){
            console.log(error1)
          }
        }
    }, 3000); //单位是毫秒

  }

  const resizeChange = () => {
    setMainContentWidth(mainContentRef.current.clientWidth)
  }


  useEffect(() => {

    window.onload = function(){
      try{
        refresh_table_tds()
      }catch(error){
        console.log(error)
      }
    } 

    // 监听
    window.addEventListener('resize', resizeChange);

    sendHttpPostRequest(
      //获取院校身份信息
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          if (response?.college_info?.college_id !== '') {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            queryClassRoomInfo(classroomId, _collegeId)
            setCollegeInfo(response.college_info)
            queryProject(_collegeId)
            const inCollege =
              collegeId !== 0 && collegeId !== null && collegeId !== ''
            const collegeTeacher =
              response.college_info?.is_college_teacher == 1
            setIsInCollege(inCollege)
            setIsCollegeTeacher(collegeTeacher)

            if (inCollege == false) {
              //没有加入院校
              message.success('请先前往个人中心认证院校身份！~')
            } else if (
              inCollege == true &&
              collegeTeacher == false &&
              project.in_classroom == 0
            ) {
              //机构学生尚未加本项目教室
              window.location.href = '/'
            }
          }
        }
      }
    )
    // getReportSubmissionList()
    queryUserInfo(userId)
    queryProjectMenu()

    // 销毁
    return () => window.removeEventListener('resize', resizeChange);
  }, [])

  // 查询答题情况总览

  const getReportSubmissionList = (reportId, userId) => {
    let data = {
      project_id: projectId,
      user_id: userId,
    }
    sendHttpPostRequest('report/api/teacher_query_classroom_student_project_task_status', data, (res) => {
      if (res.code == 0) {
        let data = res.data
        setSubmissionInfo(data.menu)
        setSubmissionInfoCount(data.sum_count)
      } else {
        message.error(res.msg)
      }
    })
  }

      /**
   * 查询报告大纲
   */
      const queryReportMenu = (report_id, user_id) => {
        sendHttpPostRequest(
          'report/api/user_query_report_chapter_list',
          {
            sessionid: Cookies.get('sessionid'),
            sid: Cookies.get('sessionid'),
            report_id: report_id,
            user_id: user_id
          },
          (response: any) => {
            message.destroy()
            if (response.code == -100) {
              // 未登录
              document.getElementById('show-login-modal')!.click()
            } else if (response.code == 0) {
              // 成功
              setReportMenu(response.data)
              const openkeys_ = response.data?.map((chapter, chapterInd) => {return 'chapter_' + chapter.id})
              setOpenKeys(openkeys_)
            } else {
              message.error(response.message)
            }
          }
        )
      }

      
  /**
   * 查询项目
   */
  const queryProject = (college_id) => {
    sendHttpPostRequest(
      'course/api/query_project_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
      },
      (response: any) => {
        // console.log(response)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          // 成功
          setProject(response.query_info)
          reportId.current = response.query_info.report_id
          queryProjectReport(userId, response.query_info.report_id)
          getReportSubmissionList(response.query_info.report_id, userId)
          queryReportMenu(response.query_info.report_id, userId)
        } /*else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/oam_login?next=oam_chapter';
                } */ else {
          message.error(response.message)
        }
      }
    )
  }

  // 查询用户信息回调
  const queryUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      setUserInfo(response.data)
    } else {
      message.error(response.message)
    }
  }
  /** 查询项目的大纲 */
  const queryProjectMenu = () => {
    sendHttpPostRequest(
      'course/api/query_chapter_list',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: projectId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          // 成功

          setProjectMenu(response.menu)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /** 查询班级信息 */
  const queryClassRoomInfo = (classroom_id, college_id) => {
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        college_id: college_id,
        course_id: projectId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setClassRoomInfo(response.query_info)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 查询用户信息
  const queryUserInfo = (userId) => {
    sendHttpPostRequest(
      'account/api/query_user_info_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        user_id: userId,
      },
      queryUserInfoCallback
    )
  } // 查询报告大纲

  
  const validateOutputIsTable = (output) => {
    if (
      output &&
      output !== '' &&
      output.indexOf('+--') >= 0 &&
      output.lastIndexOf('--+') >= 0
    ) {
      return true
    } else {
      return false
    }
  }


  const specialTreatmentfun = (report) => {
    try {
      report?.json?.map((chapter, chapterInd) => {
        chapter.tasks?.map((node, nodeInd) => {
          if (node?.exercise?.submission_info?.submission_output) {
            node.exercise.submission_info.is_table = false
            if (
              validateOutputIsTable(
                node.exercise.submission_info.submission_output
              )
            ) {
              node.exercise.submission_info.is_table = true
              let tboutput = node.exercise.submission_info.submission_output
              let tb_startInd = tboutput.indexOf('+--')
              let tb_endInd = tboutput.lastIndexOf('--+') + 3
              let pre_str = tboutput.substr(0, tb_startInd)
              let nex_str = tboutput.substr(tb_endInd)
              let prepare_marked = tboutput.slice(tb_startInd, tb_endInd)
              let tbarr = prepare_marked.split('|')
              tbarr.shift()
              tbarr.pop()
              let tbstr = tbarr.join('|')
              for (let i = 0; i < tbstr.length; i++) {
                if (
                  (tbstr[i] === '+' &&
                    tbstr[i + 1] === '-' &&
                    tbstr[i + 2] === '-') ||
                  (tbstr[i] === '+' &&
                    tbstr[i - 1] === '-' &&
                    tbstr[i - 2] === '-')
                ) {
                  tbstr = tbstr.replace(tbstr[i], '|')
                }
              }
              let marktable = marked.parse(tbstr)
              node.exercise.submission_info.output_table_str =
                pre_str + marktable + nex_str
              // return pre_str + marktable + nex_str
            }
          }
        })
      })
    } catch (e) {
      console.log(e)
    }
  }

  const queryProjectReport = (user_id, report_id) => {
    sendHttpPostRequest(
      'report/api/teacher_query_student_report/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        report_id: report_id,
        user_id: user_id,
        course_id: projectId,
        classroom_id: classroomId,
      },
      (response: any) => {
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setReport(response.query_info)
          specialTreatmentfun(response.query_info)
          console.log(response.query_info)
          setReport(response.query_info)
          try {
            // 解析 echarts
            response.query_info.json.map((tasks: any, index: number) => {
              tasks.tasks.map((_task: any, _index: number) => {
                if (_task.exercise) {
                  if (_task.exercise.submission_info.is_html) {
                    eval(_task.exercise.submission_info.js_script)
                  }
                }
              })
            })
          } catch (e) {
            console.error(e)
          }
        }
      }
    )
  }

  // 从菜单数据中构造
  const constructMenu = () => {
    return <Menu defaultOpenKeys={openkeys} mode="inline">
              { reportMenu?.map((chapter, chapterInd) => {
                return <SubMenu style={{ fontSize: 14 }} key={'chapter_' + chapter.id} title={<span title={getChapterLabels(chapterInd) + ' ' + chapter.name} >{getChapterLabels(chapterInd) + ' ' + chapter.name}</span>}>
                  {chapter.tasks?.map((node, nodeInd) => {
                      return <Menu.Item key={'node_' + node.id} style={{ fontSize: 14 }}>
                      <a
                        href={'#' + 'node_' + node.id}
                        title={String(chapterInd + 1) +'.' +String(nodeInd + 1) +' ' + node.name}
                      >

                      {node.node_complete == 1 && <span style={{display: 'inline-block', height: 6, background: '#4f46e5', width: 6, borderRadius: '50%', margin: '2px 5px 2px 0px'} }></span> }
                      {node.node_complete == 0 && <span style={{display: 'inline-block', height: 6, border: '1px solid #4f46e5', width: 6, borderRadius: '50%', margin: '2px 5px 2px 0px'} }></span> }

                                  {String(chapterInd + 1) +'.' +String(nodeInd + 1) +' ' + node.name}
                      </a>
                    </Menu.Item>
                  })}
                </SubMenu>
              }) }
    </Menu>
  }


  /** 从项目大纲中查找章Id */
  const getChapterIdByTaskId = (taskId) => {
    let result = null
    projectMenu?.map((chapter, chapterInd) => {
      chapter?.tasks.map((item) => {
        if (item.id == taskId) {
          result = chapter.id
        }
      })
    })
    return result
  }

  /** 从项目大纲中查找章和节索引 */
  const getChapterTaskIndByTaskId = (taskId) => {
    let result = { chapterInd: -1, taskInd: -1, taskName: '' }
    projectMenu?.map((chapter, chapterInd) => {
      chapter?.tasks.map((item, itemInd) => {
        if (item.id == taskId) {
          result.chapterInd = chapterInd
          result.taskInd = itemInd
          result.taskName = item.name
        }
      })
    })
    return (
      result.chapterInd + 1 + '.' + (result.taskInd + 1) + ' ' + result.taskName
    )
  }

  return (
    <Layout style={{ backgroundColor: '#fff' }}>
      <Row wrap={false} align="middle"
        style={{minWidth: 1200,height: 60,position: 'sticky',top:0,boxShadow: '0px 0 3px 1px rgba(0,0,0,0.16)'}}
      >
        <Col flex={'44px'} style={{ marginLeft: 50 }}>
          <img key={'0'} id={'menu-0'} title="" alt="logo" src={logoIconSvg2} height={36}></img>
        </Col>

        <Col flex={'auto'} style={{ minWidth: 400, marginLeft: 10 }}>
          <div style={{textAlign: 'left', color:'#666666', fontSize: 18}}>
            {project?.name}项目报告 
              <span style={{fontSize:16, marginLeft:20}}> 姓名：</span>
              <span style={{fontSize:16, padding: 5,}}>
                  {userInfo?.real_name == '' ? userInfo?.name : userInfo?.real_name}
              </span>
              <span style={{fontSize:16, marginLeft:20}}> 学号：</span>
              <span style={{fontSize:16, padding: 5,}}>
                {userInfo?.number}
              </span>
              <span style={{fontSize:16, marginLeft:20}}> 班级：</span>
              <span style={{fontSize:16, padding: 5,}}>
                {classRoomInfo?.name}
              </span>      
          </div>


        </Col>

        <Col flex={'80px'} style={{ marginRight: 50 }}>
          <Button onClick={() => window.close()} style={{color:'#4f46e5', fontSize:14, width: 90, height: 32, borderRadius: '3px 3px 3px 3px',border: '1px solid #4f46e5'}}>
            关闭预览
          </Button>
        </Col>
      </Row>  


      <div className={reportPreviewStyles.mainContent}>
        <Row wrap={false} align="top" justify="center">
          <Col
            flex={mainContentWidth > 1200 ?'364px':'264px'}
            style={{
              marginTop: 3,
              height: 'calc(100vh - 60px)',
              backgroundColor:'#F7FAFA',
              overflowY: 'scroll',
            }}
          >
            <div style={{marginLeft:0}} className={reportPreviewStyles.menuTree} > 
             {openkeys && reportMenu && constructMenu()} 
            </div>
          </Col>


          <Col ref={mainContentRef} flex="auto" style={{height: 'calc(100vh - 60px)',paddingTop:30,paddingBottom:30,overflowY: 'scroll', }}>
          <div style={{margin:'auto',minWidth: 760, maxWidth:1200}}>
              <div style={{textAlign: 'center', fontSize: 24, paddingLeft: 100,paddingRight:100, fontWeight:'bold', marginBottom:20}}>
                {project?.name}项目报告
              </div>

            <Row justify={'center'} style={{paddingLeft: 100,paddingRight:100, marginBottom:30}} >
              <div style={{textAlign: 'left', color:'#666666', fontSize: 16}}>
              <span style={{marginLeft:20}}> 姓名：</span>
              <span style={{padding: 5,}}>
                  {userInfo?.real_name == '' ? userInfo?.name : userInfo?.real_name}
              </span>
              <span style={{marginLeft:20}}> 学号：</span>
              <span style={{padding: 5,}}>
                {userInfo?.number}
              </span>
              <span style={{marginLeft:20}}> 班级：</span>
              <span style={{padding: 5,}}>
                {classRoomInfo?.name}
              </span>
              <span style={{marginLeft:20}}> 报告完成度：</span>
              <span style={{padding: 5,}}>
                {report?.report_complete_percent}%
              </span>        
              <span style={{marginLeft:20}}> 成绩：</span>
              <span style={{padding: 5,}}>
              {report?.score}
              </span>        
            </div>
            </Row>

            <Row
              align={'middle'}
              justify="space-between"
              wrap={false}
              className={reportPreviewStyles.submissionTitle}
            >
              <Col>
                <span style={{ fontSize:20, fontWeight:'bold', color:'#333', marginTop: 10 }}>项目任务完成情况总览</span> 
                <span style={{ fontSize:14, color:'#999', marginLeft: 10 }}> （此总览仅统计代码相关任务的完成情况）</span>
              </Col>
              <Col>
                <Row align={'middle'} style={{ gap: '20px' }}>
                  <Col>
                    <Row align={'middle'} wrap={false} style={{ gap: '10px' }}>
                      <Col className={reportPreviewStyles.statusBlock + ' ' + reportPreviewStyles.isTrue}></Col>
                      <Col>通过 {submissionInfoCount?.pass_count}</Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row align={'middle'} wrap={false} style={{ gap: '10px' }}>
                      <Col
                        className={reportPreviewStyles.statusBlock +' ' +reportPreviewStyles.isFalse}
                      ></Col>
                      <Col>未通过 {submissionInfoCount?.fail_count}</Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row align={'middle'} wrap={false} style={{ gap: '10px' }}>
                      <Col className={reportPreviewStyles.statusBlock +' ' +reportPreviewStyles.unsubmit}></Col>
                      <Col>未提交 {submissionInfoCount?.not_count}</Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>

            {submissionInfo?.map((chapter, chapterInd) => (
              <div key={chapter.id} style={{paddingLeft:100, paddingRight:100}}>
                <Row  align={'middle'} style={{ gap: '5px', marginBottom: '20px' }}>
                  <Col className={reportPreviewStyles.submissionChapter}> 
                  </Col>
                  <Col className={reportPreviewStyles.chapterName}>
                    {chapter.name}
                  </Col>
                </Row>
                <Row
                  align={'middle'}
                  style={{ marginBottom: '5px', gap: '15px' }}
                >
                  {chapter.tasks?.map((task, index) =>
                    task.status == 0 ? (
                      <Tooltip key={task.id}  title={'任务 ' + String(chapterInd+1) + '.' +String(index + 1) + ' ' +task.name}>   
                      <Col  key={task.id} className={reportPreviewStyles.statusItem +' ' +reportPreviewStyles.unsubmit}> 
                        {index + 1}
                      </Col> </Tooltip>
                    ) : task.status == 2 ? (
                      <Tooltip key={task.id}  title={'任务 ' + String(chapterInd+1) + '.' +String(index + 1) + ' ' +task.name}> 
                      <Col className={reportPreviewStyles.statusItem + ' ' + reportPreviewStyles.isTrue} key={task.id} >
                        {index + 1}
                      </Col> </Tooltip>
                    ) : task.status == 1 ? (
                      <Tooltip key={task.id}  title={'任务 ' + String(chapterInd+1) + '.' +String(index + 1) + ' ' +task.name}>  
                      <Col key={task.id} className={reportPreviewStyles.statusItem +' ' +reportPreviewStyles.isFalse}>
                        {index + 1}
                      </Col> </Tooltip>
                    ) : (
                      ''
                    )
                  )}
                </Row>
              </div>
            ))}

            {report?.json?.map((chapter, chapterInd) => {
              return (
                <div id={'chapter_' + chapter.id} key={chapter.id} style={{paddingLeft: 100,paddingRight:100}}>
                  <div style={{ marginBottom: 20, marginTop: 10, fontWeight:'bold', fontSize:20}}>
                    {getChapterLabels(chapterInd)} {chapter?.name}
                  </div> {/**章节名 */}
                  {chapter?.tasks?.map((reportNode, nodeInd) => {
                    return (
                      <div id={'node_' + reportNode.id} key={reportNode.id}>
                        <div style={{fontSize: 18,textAlign: 'left',marginBottom: 10,marginTop: 10,}}>
                          {chapterInd + 1 + '.' + (nodeInd + 1) + ' '}{' '}
                          {reportNode?.name}
                        </div>  {/** 1/ 节点名称 */}

                        <div>
                          {/** 2/ 节点说明 */}
                          <div className={reportPreviewStyles.nodeDesImage}>
                            {reportNode?.description && (
                              <ReactMarkdown className={reportPreviewStyles.reactmarkdown} remarkPlugins={[gfm, remarkMath]} rehypePlugins={[rehypeHighlight,rehypeKatex,rehypeRaw,]}>
                                {reportNode?.description}
                              </ReactMarkdown>
                            )} 
                          </div>
                          {/** 4/ 如果节点关联任务，这里放置任务输出 */}
                          {reportNode?.exercise_id != 0  && reportNode?.exercise  && reportNode?.type == 1 && (
                            <div className={reportPreviewStyles.taskRungingOutputDiv} >
                              {reportNode?.exercise?.submission_info?.submission_time !== '' && (
                                <div >
                                   <div style={{maxHeight:400, overflowY:'scroll'}}>
                                      {reportNode?.exercise?.submission_info?.is_html == true && (
                                        <div style={{display: 'flex',justifyContent: 'center',overflow: 'auto',backgroundColor: '#fff',}}
                                          dangerouslySetInnerHTML={{__html: reportNode?.exercise.submission_info.submission_output?.replaceAll('\n',''),}}
                                        />
                                      )}

                                      {reportNode?.exercise?.submission_info?.is_html == false && !reportNode?.exercise?.submission_info?.is_table && (
                                       <div style={{color: '#333',marginLeft: 20,marginRight: 20,marginBottom: 10,paddingTop: 0,borderRadius: 5,}} >
                                       <ReactMarkdown
                                       //className={taskLearnStyles.outputRenderMarkdown}
                                       remarkPlugins={[gfm, remarkMath]}
                                       rehypePlugins={[
                                         rehypeHighlight,
                                         rehypeKatex,
                                         rehypeRaw,
                                       ]}
                                       >
                                       {
                                         reportNode?.exercise.submission_info.submission_output.replaceAll('\n', '\n\n')
                                       }
                                       </ReactMarkdown>
                                       </div>
                                      )}

                                      {/* 如果是表格字符串  单独处理 */}
                                      {reportNode?.exercise?.submission_info?.is_html == false && reportNode?.exercise?.submission_info?.output_table_str && reportNode?.exercise?.submission_info?.is_table && (
                                          <div className={reportPreviewStyles.tableWapper} style={{color: '#333',marginLeft: 20,marginRight: 20,marginBottom: 10,paddingTop: 0,borderRadius: 5,}}
                                            dangerouslySetInnerHTML={{__html:reportNode?.exercise?.submission_info?.output_table_str,}}
                                          ></div>
                                      )}
                                    </div>

                                    <div>
                                    {reportNode?.exercise?.submission_info?.submission_image && !reportNode?.exercise?.submission_info?.is_animation && reportNode?.exercise?.submission_info?.submission_image?.map(
                                            (imageBase64, ind) => {
                                              return (
                                                <div style={{margin: 10,textAlign: 'center',}}
                                                  key={String(ind)}
                                                >
                                                  <img src={'data:image/jpg;base64,' +imageBase64} style={{maxHeight:300, backgroundColor: '#fff',borderRadius: 3,}}></img>
                                                </div>
                                              )
                                            }
                                          )}

                                        {reportNode?.exercise?.submission_info?.submission_image && reportNode?.exercise?.submission_info?.is_animation && 
                                          <div style={{margin: 10,textAlign: 'center',}}>
                                            <img 
                                              style={{ maxWidth:'100%'}}
                                              id="animation_img"
                                              src={
                                                'data:image/jpg;base64,' + reportNode.exercise.submission_info.submission_image[0]
                                              }
                                              alt=""
                                            />
                                          </div>
                                        }
                                    </div>
                
                                </div> )}

                                {
                                reportNode?.exercise?.submission_info?.submission_time !== '' && (
                                <div style={{ color: '#999999', textAlign: 'right' }}>
                                    （结果由任务{' '}{getChapterTaskIndByTaskId(reportNode?.exercise_id)} 生成）
                                  </div> )}

                                {/** 以下是任务没提交 */}
                                {
                                  reportNode?.exercise?.submission_info?.submission_time == '' && (
                                    <div className={reportPreviewStyles.nodeToComplete}
                                      style={{paddingTop: 20, paddingBottom:20,marginBottom: 10,textAlign: 'center',cursor: 'pointer',}}
                                      onClick={() => {window.open(`task_learn?project/${projectId}/chapter/${getChapterIdByTaskId(reportNode?.exercise_id)}/task/${reportNode?.exercise_id}/`)
                                      }}
                                    >
                                      <RightCircleOutlined
                                        style={{ fontSize: 24 }}
                                      />
                                      <div>
                                        本结果由任务{' '}{getChapterTaskIndByTaskId(reportNode?.exercise_id)}{' '}自动生成
                                      </div>
                                      <div>该学生未完成该任务</div>
                                    </div>
                                  )}
 
                            </div> // taskRunningOutputDiv end
                          )}

                          {reportNode?.need_input_info == 2  && reportNode?.input_info.trim() != '' 
                            && <div
                                id="user-input-content"
                                className={
                                  reportPreviewStyles.userReportContentWrapper
                                }
                                style={{backgroundColor: reportNode?.content.trim() != '' ? '#F7FAFA':'#FFF4F4'}}
                                >
                                  <div style={{color:"#4f46e5", marginBottom:10}}> {reportNode?.input_info} </div>
                                    {reportNode?.content.trim() != '' ? 
                                    <ReactMarkdown
                                      remarkPlugins={[gfm, remarkMath]}
                                      rehypePlugins={[rehypeHighlight, rehypeKatex]}
                                    >
                                      {reportNode?.content}
                                    </ReactMarkdown> : <div style={{color:'#666666'}}>尚未作答</div>}
                        
                                </div> 
                             }

                        </div>
                      </div>
                    )
                  })}
                </div>
              )
            })}

          </div>  
          </Col>
        </Row>
      </div>
    </Layout>
  )
}
export default UserReportPreview
